var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"mainCtrl"}},[_c('services-tree',{ref:"servicesTree",attrs:{"is-support":_vm.isSupport,"all-prices":_vm.prices,"treetable":_vm.treetable}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }